import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { ContentProvider } from "@/contexts/ContentContext";
import { AppPagesProvider } from "@/contexts/AppPagesContext";
import PlayFoxLanding from "@/pages/PlayFoxLanding";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPage from "@/pages/PrivacyPage";
import AppPageView from "@/pages/AppPageView";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ContentProvider>
            <AppPagesProvider>
              <Routes>
                <Route path="/" element={<PlayFoxLanding />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/apps/:slug" element={<AppPageView />} />
                <Route path="/admin" element={<AdminLogin />} />
                <Route path="/admin/dashboard" element={<AdminDashboard />} />
                <Route path="*" element={<PlayFoxLanding />} />
              </Routes>
              <Toaster position="bottom-right" richColors closeButton />
            </AppPagesProvider>
          </ContentProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
